module.exports = {
          srcSet: __webpack_public_path__ + "public/4aaff331c226aef51717c9319fdb8a9a-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/4aaff331c226aef51717c9319fdb8a9a-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/4aaff331c226aef51717c9319fdb8a9a-40.png",
          toString:function(){return __webpack_public_path__ + "public/4aaff331c226aef51717c9319fdb8a9a-40.png"},
          
          width: 40,
          height: 40
        }